<template>
  <div class="opage">
    <!-- 普检单，精检单 -->
    <div>
      <detailHeader></detailHeader>
      <div style="padding: 0 24px">
        <div class="tableBody">
          <!-- 开始处理 -->
          <div style="margin-bottom: 24px">
            <el-button type="primary" class="primary" v-if="!start && isAuth(206)" @click="inspectStartLabel">
              {{ $t("message.startProcessing") }}
            </el-button>
            <el-button type="primary" v-else>
              {{ $t("message.inTheProcess") }}
            </el-button>
          </div>
          <div class="mytable">
            <div class="tul ttt head_title">
              <!-- 选择 -->
              <div class="tli ttt select ">{{ $t("message.select") }}</div>
              <!-- 番号 -->
              <div class="tli ttt NO ">{{ $t('message.mash') }}</div>
              <!-- 照片 -->
              <div class="tli ttt">{{ $t("message.pic") }}</div>
              <!-- 业务编辑商品属性 -->
              <div class="tli ttt theBusinessEditsTheCommodityProperties listTd">
                {{ $t("message.theBusinessEditsTheCommodityProperties") }}
              </div>
              <!-- 担当备注 -->
              <div class="tli ttt remarkTd businessRemark">
                {{ $t("message.responsibleForRemarks") }}
              </div>
              <!-- 核查员备注 注:核查员就是配货 -->
              <div class="tli ttt remarkTd distributionRemark">
                {{ $t("message.verifierSNotes") }}
              </div>
              <!-- 待处理附加服务数量 -->
              <div class="tli ttt listTd ">
                {{ $t("message.numberOfAdditionalServicesToBeProcessed") }}
              </div>
              <!-- 待布标处理数 -->
              <div class="tli ttt">
                {{ $t("message.numberOfLabelsToBeLaid") }}
              </div>
              <!-- 单价(元) -->
              <div class="tli ttt">{{ $t("message.priceYuan") }}</div>
              <!-- 操作数量-->
              <div class="tli ttt listTd" style="background: #fee0c3">
                {{ $t("message.operationQuantity") }}
              </div>
              <!-- 布标处理-->
              <div class="tli ttt listTd" style="background: #fee0c3;flex: 2.5;">
                {{ $t("message.clothLabelProcessing") }}
              </div>
              <!--  普/精检问题数 -->
              <div class="tli ttt">
                <p>{{ $t("message.numberOfGeneralprecisionTestProblems") }}</p>
              </div>
              <!--  布标问题数-->
              <div class="tli ttt">
                <p>{{ $t("message.numberOfLabelLayoutProblems") }}</p>
              </div>
              <!-- 物流号 -->
            </div>
            <div class="tcon" v-for="(orderItem, orderIndex) in tableData" :key="orderIndex">
              <div class="tul tconHead">
                <div class="tconHeadOpt flexDirColumn">
                  <div>
                    <!-- 提出时间 -->
                    <p>
                      {{ $t("message.forwardTime") }}：{{ orderItem.submit_at }}
                    </p>
                  </div>
                </div>
                <div class="tconHeadOpt yellowFont" style="flex: 1.5;">
                  <!-- 普检单   -->
                  {{ orderItem.inspect_sn }}
                  <span class="redFont"> </span>
                </div>
                <div class="tconHeadOpt">
                  <!-- 配货   -->
                  {{ $t("message.distribution") }}：
                  <span>{{ orderItem.p_admin.realname }} </span>
                </div>
                <div class="tconHeadOpt">
                  <!-- 普/精检员   -->
                  {{ $t("message.generalQualityInspector") }}：
                  <span>{{ orderItem.j_admin.realname }} </span>
                </div>
                <div class="tconHeadOpt">
                  <!-- 布标处理   -->
                  {{ $t("message.clothLabelTreatment") }}：
                  <span>
                    {{ orderItem.label_admin ? orderItem.label_admin.realname : "" }}
                  </span>
                </div>
                <div class="tconHeadOpt flexDirColumn">
                  <div>
                    <p>
                      <router-link :to="'/orderPaymentDetail?order_sn=' + orderItem.order.order_sn" class="yellowFont"
                        target="_blank">
                        {{ orderItem.order.order_sn }}
                      </router-link>

                    </p>
                    <p>{{ orderItem.order.user.realname }}</p>
                  </div>
                </div>
                <div class="tconHeadOpt">
                  <!-- 交易号 -->
                  {{ $t("message.transactionNumber") }}
                  <span class="yellowFont">{{ orderItem.purchase_no }}</span>
                </div>
                <div class="tconHeadOpt">
                  <!-- 业务 -->
                  {{ $t("message.business") }}：
                  {{ orderItem.order.y_admin.realname }}
                </div>
                <div class="tconHeadOpt">
                  <!-- 采购 -->
                  {{ $t("message.purchase") }}：
                  {{ orderItem.order.g_admin.realname }}
                </div>
                <div class="tconHeadOpt">
                  <!-- 配货 -->
                  {{ $t("message.distribution") }}：
                  {{ orderItem.order.p_admin.realname }}
                </div>
              </div>
              <div class="tul tbo" v-for="(goodsItem, goodsIndex) in orderItem.list" :key="goodsIndex">
                <!-- 选择 -->
                <div class="tli  select flex05">
                  <el-checkbox v-model="goodsItem.checked" @change="changeItem" :disabled="!start"></el-checkbox>
                </div>
                <div class="tli  NO flex05">{{ goodsItem.sorting }}</div>
                <!-- 照片 -->
                <div class="tli ">
                  <uploadFile :imgList="goodsItem.pic" :showDel="false" target="hover"></uploadFile>
                </div>
                <!-- 业务编辑商品属性 -->
                <div class="tli  theBusinessEditsTheCommodityProperties listTd">
                  <div>
                    <el-popover placement="bottom" trigger="hover">
                      <p v-for="(goodsDetailItem, goodsDetailIndex) in goodsItem.detail_y" :key="goodsDetailIndex">
                        {{ goodsDetailItem.key }}：
                        {{ goodsDetailItem.value }}
                      </p>
                      <div slot="reference">
                        <p v-for="(goodsDetailItem, goodsDetailIndex) in goodsItem.detail_y"
                          :key="'goodsDetail' + goodsDetailIndex">
                          {{ goodsDetailItem.key }}：
                          {{ goodsDetailItem.value }}
                        </p>
                      </div>
                    </el-popover>
                  </div>
                </div>
                <!-- 担当备注 -->
                <div class="tli remarkTd businessRemark">
                  <div style="width: 100%;">
                    <el-popover placement="top-start" width="450" trigger="hover">
                      <p style="font-size: 24px;padding: 10px;">{{ goodsItem.y_remark }}</p>
                      <textarea disabled v-model="goodsItem.y_remark" slot="reference"></textarea>
                    </el-popover>
                  </div>
                </div>
                <!-- 核查员备注 注:核查员就是配货 -->
                <div class="tli remarkTd distributionRemark">
                  <div style="width: 100%;">
                    <el-popover placement="top-start" width="450" trigger="hover">
                      <p>{{ goodsItem.p_remark }}</p>
                      <textarea disabled v-model="goodsItem.p_remark" slot="reference"></textarea>
                    </el-popover>
                  </div>
                </div>
                <!-- 附加服务 -->
                <div class="tli  listTd">
                  <div>
                    <p v-for="(optionItem, optionIndex) in goodsItem.option" :key="'option' + optionIndex"
                      style="color: rgb(3, 110, 184);">
                      {{ optionIndex + 1 }} {{ optionItem.name }} *
                      {{ optionItem.num }}
                    </p>
                  </div>
                </div>
                <!-- 待提交检品数 -->
                <div class="tli ">
                  {{ goodsItem.label_should_num }}
                </div>
                <!-- 单价(元) -->
                <div class="tli ">
                  {{ goodsItem.confirm_price }}
                </div>
                <!-- 操作数量-->
                <div class="tli listTd">
                  <div class="template">
                    <!-- 实缝标数 -->
                    <div class="row">
                      <div class="label"> {{ $t("message.numberOfBidDemolitions") }}</div>
                      <div class="value"> <el-input v-model="goodsItem.label_on" onfocus="this.select()"
                          :disabled="!start" type="number"></el-input></div>
                    </div>
                    <!-- 实拆标数 -->
                    <div class="row">
                      <div class="label"> {{ $t("message.numberOfActualSplitBids") }}</div>
                      <div class="value"> <el-input v-model="goodsItem.label_off" onfocus="this.select()"
                          :disabled="!start" type="number"></el-input></div>
                    </div>
                  </div>
                </div>
                <!--布标处理数量 -->
                <div class="tli listTd " style="flex: 2.5;">
                  <div class="template">
                    <!--  布标处理数量- -->
                    <div class="row">
                      <div class="label"> {{ $t("message.quantityOfClothLabelProcessing") }}</div>
                      <div class="value"> <el-input v-model="goodsItem.label_num" onfocus="this.select()" disabled
                          type="number"></el-input></div>
                    </div>
                    <!-- 布标处理数量差 -->
                    <div class="row">
                      <div class="label"> {{ $t("message.theQuantityOfClothProcessingIsPoor") }}</div>
                      <div class="value"> {{ goodsItem.label_should_num - goodsItem.label_num - goodsItem.label_bad_num
                      }}</div>
                    </div>
                    <!-- 布标不良数 -->
                    <div class="row">
                      <div class="label"> {{ $t("message.numberOfDefectiveClothLabels") }}</div>
                      <div class="value"> <el-input v-model="goodsItem.label_bad_num" onfocus="this.select()"
                          :disabled="!start" type="number"></el-input></div>
                    </div>
                  </div>
                </div>
                <!--  普/精检问题数 -->
                <div class="tli ">
                  <div>
                    <!--实检数   -->
                    <p>
                      {{ $t("message.checkNumber") }}:{{ goodsItem.inspect_num }}
                    </p>
                    <!-- 数量差 -->
                    <p>
                      {{ $t("message.poorQuantity") }}:
                      {{ goodsItem.num - goodsItem.inspect_num - goodsItem.inspect_bad_num }}
                    </p>
                    <!-- 不良数 -->
                    <p>
                      {{ $t("message.adverseNumber") }}:{{ goodsItem.inspect_bad_num }}
                    </p>
                  </div>
                </div>
                <!-- 布标问题数 -->
                <div class="tli "></div>
                <!-- 物流号 -->
              </div>
            </div>
            <!-- 数据为空 -->
            <div class="tul tNullData" v-if="tableData.length == 0">
              {{ $t("message.dataIsNull") }}
            </div>
          </div>
        </div>
        <!-- 备注 -->
        <div class="remarkList">
          <div class="item">
            <!-- 业务订单备注： -->
            <h6>{{ $t("message.serviceOrderRemarks") }}：</h6>
            <div class="remark-box">
              <div class="items" v-for="(item, index) in remarkSet.order_remark_set" :key="index">
                <div class="order">{{ item.order_Sn }}</div>
                <div class="remark">{{ item.y_remark }}</div>
              </div>
            </div>
          </div>
          <!-- 检品单备注： -->
          <div class="item">
            <h6>{{ $t("message.remarksOnInspectionList") }}：</h6>
            <div class="remark-box">
              <div class="items" v-for="(item, index) in remarkSet.inspect_remark_set" :key="index">
                <div class="order">{{ item.inspect_sn }}</div>
                <div class="remark">{{ item.inspect_remark }}</div>
              </div>
            </div>
          </div>
          <!-- 复检原因-->
          <div class="item">
            <div class="remark-box" v-for="(item, index) in remarkSet.inspect_recheck_set" :key="index">
              <h6>
                {{ $t("message.reasonForReinspection") }}：{{ item.recheck_reason_name }}
              </h6>
              <div class="items">
                <!-- 具体原因 -->
                <div class="remark">{{ item.recheck_reason_detail }}</div>
                <!-- 是否需要布标处理： -->
                <!-- 是否需要计算绩效 -->
                <div class="order radio">
                  <p>
                    <span> {{ $t("message.whetherToClothLabels") }} :</span>
                    {{ item.is_need_label == 1 ? "是" : "否" }}
                  </p>
                  <p>
                    <span>
                      {{ $t("message.whetherPerformanceNeedsToBeCalculated") }}
                      :</span>{{ item.is_need_performance == 1 ? "是" : "否" }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 用户操作 -->
    <div class="userOperations" v-if="start">
      <div class="check">
        <el-checkbox v-model="checked" @change="allChecked"></el-checkbox>
        <!-- 全选 -->
        <span> {{ $t("message.allChecked") }}</span>
      </div>
      <!-- 复制选择商品信息 -->
      <el-button type="primary" class="primary" @click="copyText">
        {{ $t("message.copySelectedProductInformation") }}
      </el-button>
      <!-- 临时保存 -->
      <el-button type="success" @click="inspectSaveTemp" v-if="isAuth(208)">{{ $t("message.temporaryStorage") }}
      </el-button>
      <!-- 布标处理完了-->
      <el-button type="primary" @click="inspectSubmitLabel" v-if="isAuth(208)">
        {{ $t("message.theClothLabelIsFinished") }}
      </el-button>
    </div>
    <!-- 注意事项 -->
    <getNotice ref="getNotice" />
  </div>
</template>
<script>
import uploadFile from "@/components/uploadFile/uploadFile.vue";
import detailHeader from "@/components/header/detailHeader";
export default {
  data() {
    return {
      start: false,
      remarkSet: {},
      purchase: {}, //配送单详情返回的所有数据
      recheckReason: [], //复检原因列表
      tableData: [],
      checkedList: [], //选中的数据
      checked: false,
      remark: "", //备注
    };
  },
  metaInfo() {
    return {
      title: !this.start ? '布标待处理' : '布标处理中',
    };
  },
  components: {
    uploadFile,
    detailHeader,
  },
  computed: {},
  created() {
    this.getData();
    this.recheckReasonMap();
  },
  methods: {
    // 获取详情数据
    getData() {
      let datas = {
        purchase_no: this.$route.query.purchase_no,
        express_no: this.$route.query.express_no,
        status: this.$route.query.status,
      };
      this.$api.inspectionApi.inspectPreview(datas).then((res) => {
        this.remarkSet = res.data.remarkSet;
        let user_id = res.data.list != false ? res.data.list[0].order.user.id : ''
        if (!user_id) return false
        this.$refs.getNotice.getNotice(user_id, "检品注意事项")
        // 处理商品列表数据
        this.processingData(res.data.list);
        this.tableData = res.data.list;
        this.checked = true
        this.allChecked()
      });
    },
    // 获取复检原因所有选项
    recheckReasonMap() {
      this.$api.inspectionApi.recheckReasonMap().then((res) => {
        this.recheckReason = res.data;
      });
    },
    // 处理详情数据
    processingData(data) {
      data.forEach((dataItem) => {
        // 添加收起与展开参数
        dataItem.checked = false;
        dataItem.list.forEach((items) => {
          items.checked = false;
          items.label_on = 0
          items.label_off = 0
          if (items.option) {
            items.option = items.option.filter(opin => opin.name == '缝布标' || opin.name == '取布标')
            items.option.forEach(opti => {
              if (opti.name == '缝布标') {
                items.label_on = opti.num > items.label_should_num ? items.label_should_num : opti.num
              }
              if (opti.name == '取布标') {
                items.label_off = opti.num > items.label_should_num ? items.label_should_num : opti.num
              }
            })
          }
          items.label_num = items.label_should_num
        });
        this.start = dataItem.list.every((item) => item.label_start_at != null);
      });
    },
    // 单选
    changeItem() {
      this.checkedList = [];
      let allcheck = true;
      this.tableData.forEach((item) => {
        item.list.forEach((inspect_detailItem) => {
          if (inspect_detailItem.checked) {
            this.checkedList.push(inspect_detailItem);
          } else {
            allcheck = false;
          }
        });
      });
      this.checked = allcheck;
      this.$forceUpdate();
    },
    //  全选
    allChecked() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.list.forEach((inspect_detailItem) => {
          inspect_detailItem.checked = this.checked;
          if (inspect_detailItem.checked) {
            this.checkedList.push(inspect_detailItem);
          }
        });
      });
      this.$forceUpdate();
    },
    // 复制格式与检品列表一致，多番商品按番号依次排列
    copyText() {
      const selectedList = []
      this.tableData.forEach((orderItem) => {
        orderItem.list.forEach((goodsItem) => {
          if (goodsItem.checked) {
            selectedList.push({
              order_sn: orderItem.order.order_sn,
              purchase_no: orderItem.purchase_no,
              sorting: goodsItem.sorting,
              link: goodsItem.link
            })
          }
        })
      })
      if (selectedList.length === 0) {
        return this.$message.error(this.$t("message.pleaseSelectAtLeastOne"))
      }
      selectedList.sort((a, b) => Number(a.sorting) - Number(b.sorting))
      const copyContent = selectedList.map(item => {
        return `${item.order_sn}\n${item.sorting}番 ${item.link}\n交易号: ${item.purchase_no}`
      }).join('\n')
      this.copy(copyContent)
    },
    // 获取选中商品的id
    getChioseId() {
      let ids = [];
      this.checkedList.forEach((checkedItem) => {
        ids.push(checkedItem.id);
      });
      return ids;
    },
    // 检品操作界面-普检/精检临时保存
    inspectSaveTemp() {
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        list: [],
      };
      this.checkedList.forEach((item) => {
        datas.list.push({
          id: item.inspect_detail_id,
          inspect_num: item.inspect_num,
          inspect_bad_num: item.inspect_bad_num,
          label_on: item.label_on,
          label_off: item.label_off,
        });
      });

      this.$api.inspectionApi.inspectSaveTemp(datas).then((res) => {
        this.$message.success(res.msg);
        this.getData();
      });

    },
    // 布标处理完了
    inspectSubmitLabel() {
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        list: [],
      };
      this.checkedList.forEach((item) => {
        datas.list.push({
          id: item.inspect_detail_id,
          label_num: item.label_num,
          label_bad_num: item.label_bad_num,
          label_on: item.label_on,
          label_off: item.label_off,
        });
      });

      this.$api.inspectionApi.inspectSubmitLabel(datas).then((res) => {
        this.$message.success(res.msg);
        this.getData();
      });
    },
    //开始检品
    inspectStartLabel() {
      let datas = {
        ids: [],
      };
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          datas.ids.push(items.inspect_detail_id);
        });
      });
      this.$api.inspectionApi.inspectStartLabel(datas).then((res) => {
        this.$message.success(res.msg);
        this.start = true;
      });
    },
  },
};
</script>
<style lang='scss' scoped='scoped'>
@import "@/css/mixin.scss";

* {
  box-sizing: border-box;
  font-family: 思源黑体;
}

.opage {
  min-width: 1910px;
  min-height: 100vh;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  .userOperations {
    background: #f8f8f8;
    position: sticky;
    bottom: 0;
    display: flex;

    align-items: center;
    padding: 10px 24px;
    border: 1px solid #edeff4;
    border-radius: 8px;
    position: sticky;
    top: 10px;
    margin: 24px 24px 0;

    .check {
      margin-right: 52px;

      span {
        margin-left: 8px;
      }
    }

    .el-button {
      margin-left: 0;
      margin-right: 16px;
    }


    .operationsRight {
      display: flex;
      align-items: center;

      .el-button {
        margin-left: 0;
        margin-right: 16px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

.tableBody {
  background: #f8f8f8;
  border-radius: 8px;
  padding: 25px;

  .mytable {
    .head_title {
      position: sticky !important;
      top: 0;
      z-index: 999;
      background-color: #EDEFF4;
      border-radius: 4px;
      height: 40px;
      margin-bottom: 12px;
      text-align: center;
    }

    .tul {
      display: flex;
      padding: 0 12px;

    }

    .tbo {
      padding: 12px 0;
      border-bottom: 1px solid #ccc;

      /deep/.el-input__inner {
        padding: 0;
        text-align: center;
      }

      p {
        line-height: 25px;
      }
    }

    .tli {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 8px;

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }

    .select,
    .NO {
      flex: 0.5;
    }

    .remarkTd {
      flex: 4;

      textarea {
        resize: none;
        width: 100%;
        height: 152px;
        padding: 10px;
        font-size: 18px;
        background-color: #fff;
        color: #000;
        border-radius: 4px;
      }
    }

    // 检品时优先展示业务备注，配货备注保留较小宽度
    .businessRemark {
      flex: 4;
    }

    .distributionRemark {
      flex: 1.5;
    }

    .listTd {
      flex: 2;
    }

    .jinPin {
      flex: 2.2;
    }

    .template {
      .row {
        display: flex;
        margin-bottom: 8px;
        line-height: 40px;

        &:nth-last-child(1) {
          margin-bottom: 0;
        }

        .label {
          flex: 1;
          margin-right: 8px;
          text-align: right;
        }

        .value {
          width: 60px;
        }
      }
    }

    .tconHead {
      display: flex;
      background-color: #545469;
      flex-direction: row;
      align-items: center;
      height: 60px;
      border-radius: 4px;
      padding: 10px 24px;
      color: #fff;

      .tconHeadOpt {
        flex: 1;
        margin-right: 36px;

        &:nth-last-child(1) {
          margin-right: 0;
        }
      }

      .flexDirColumn {
        flex: 2;
      }
    }

    .tNullData {
      font-size: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      color: #bbbec7;
    }
  }
}

.remarkList {
  margin-top: 24px;
  padding: 24px;
  background: #f8f8f8;
  border: 1px solid #edeff4;
  border-radius: 8px;
  display: flex;

  .item {
    flex: 1;
    margin-right: 48px;

    h6 {
      font-size: 18px;
      margin-bottom: 12px;
    }

    .items {
      display: flex;
      margin-bottom: 12px;

      .order {
        flex: 1;
        color: #000;
      }

      .remark {
        flex: 2;
        padding: 5px;
        border: 1px solid #e8e8e8;
        border-radius: 5px;
        height: 80px;
      }

      .radio {
        margin-left: 20px;

        p {
          font-size: 16px;
          margin-bottom: 10px;
          display: flex;

          span {
            flex: 3;
          }
        }
      }
    }
  }
}

.redFont {
  color: #fa5058;
}

.yellowFont {
  color: #f9f871;
}

.el-checkbox {
  transform: scale(1.5);
}
</style>
